<header class="login-header">
  <div class="container">
    <app-logo />

    <div class="disclaimer">
      <app-icon name="IdCard" size="md" />
      <span class="text">{{ "login.disclaimer.title" | translate }}*</span>
    </div>

    <div class="buttons">
      <app-link-button link="/service" icon="Mail" variant="minimal">{{ "common.action.contact_support" | translate }}</app-link-button>
      <div class="separator"></div>
      <app-link-button icon="LogOut" link="https://www.ophardt.com/" variant="minimal">{{ "common.action.log_out" | translate }}</app-link-button>
    </div>
  </div>
</header>
